import { useState, useEffect } from 'react';

const slides = [
  {
    id: 1,
    image: 'https://public.readdy.ai/ai/img_res/3e891d7b16edce07ee1a2df72c7d0ee1.jpg',
  },
  {
    id: 2,
    image: 'https://readdy.ai/api/search-image?query=Adorable%20children%20wearing%20fresh%20spring%20pastel%20clothing%20in%20mint%20green%20pink%20and%20sky%20blue%20colors%20in%20a%20bright%20airy%20studio%20with%20white%20background%20showcasing%20comfortable%20Korean%20kids%20fashion%20designs&width=1920&height=800&seq=hero2&orientation=landscape',
  },
  {
    id: 3,
    image: 'https://readdy.ai/api/search-image?query=Cute%20Korean%20children%20in%20trendy%20casual%20outfits%20smiling%20happily%20in%20a%20modern%20bright%20studio%20with%20clean%20white%20background%20showcasing%20quality%20kids%20fashion%20with%20fast%20delivery%20service%20concept&width=1920&height=800&seq=hero3&orientation=landscape',
  }
];

export default function Hero() {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => clearInterval(timer);
  }, []);

  const goToSlide = (index: number) => {
    setCurrentSlide(index);
  };

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  return (
    <div className="relative w-full h-[600px] overflow-hidden">
      {/* 輪播圖片 */}
      {slides.map((slide, index) => (
        <div
          key={slide.id}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            index === currentSlide ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <img
            src={slide.image}
            alt={`Banner ${slide.id}`}
            className="w-full h-full object-cover object-top"
          />
        </div>
      ))}

      {/* 左右箭頭 */}
      <button
        onClick={prevSlide}
        className="absolute left-6 top-1/2 -translate-y-1/2 w-12 h-12 flex items-center justify-center bg-white/20 hover:bg-white/30 backdrop-blur-sm rounded-full transition-all cursor-pointer"
        aria-label="上一張"
      >
        <i className="ri-arrow-left-s-line text-white text-2xl"></i>
      </button>
      <button
        onClick={nextSlide}
        className="absolute right-6 top-1/2 -translate-y-1/2 w-12 h-12 flex items-center justify-center bg-white/20 hover:bg-white/30 backdrop-blur-sm rounded-full transition-all cursor-pointer"
        aria-label="下一張"
      >
        <i className="ri-arrow-right-s-line text-white text-2xl"></i>
      </button>

      {/* 指示器 */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex gap-3">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => goToSlide(index)}
            className={`w-3 h-3 rounded-full transition-all cursor-pointer ${
              index === currentSlide
                ? 'bg-white w-8'
                : 'bg-white/50 hover:bg-white/70'
            }`}
            aria-label={`跳轉到第 ${index + 1} 張`}
          />
        ))}
      </div>
    </div>
  );
}
